(function () {
  'use strict';

  var REQUIRED_NAMES = [
    'data_solicitacao',
    'razao_social',
    'cnpj',
    'fone_lojista',
    'email_lojista',
    'consumidor_final',
    'descricao_ocorrencia'
  ];

  // Make recusa requisições acima de 5 MB (multipart incluso), então cada arquivo vai sozinho e com folga.
  var MAX_FILE_BYTES = 4 * 1024 * 1024;
  var COMPRESS_ABOVE_BYTES = 1.5 * 1024 * 1024;
  var IMAGE_MAX_DIMENSION = 1920;
  var IMAGE_QUALITY = 0.82;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function todayISODate() {
    var now = new Date();
    var month = String(now.getMonth() + 1).padStart(2, '0');
    var day = String(now.getDate()).padStart(2, '0');
    return now.getFullYear() + '-' + month + '-' + day;
  }

  function formatBytes(bytes) {
    if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1).replace('.', ',') + ' MB';
  }

  function onlyDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function maskCnpj(value) {
    var d = onlyDigits(value).slice(0, 14);
    if (d.length > 12) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2}).*/, '$1.$2.$3/$4-$5');
    if (d.length > 8) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{0,4}).*/, '$1.$2.$3/$4');
    if (d.length > 5) return d.replace(/^(\d{2})(\d{3})(\d{0,3}).*/, '$1.$2.$3');
    if (d.length > 2) return d.replace(/^(\d{2})(\d{0,3}).*/, '$1.$2');
    return d;
  }

  function isValidCnpj(value) {
    var d = onlyDigits(value);
    if (d.length !== 14 || /^(\d)\1{13}$/.test(d)) return false;

    function checkDigit(length) {
      var sum = 0;
      var weight = length - 7;
      for (var i = 0; i < length; i++) {
        sum += parseInt(d.charAt(i), 10) * weight--;
        if (weight < 2) weight = 9;
      }
      var rest = sum % 11;
      return rest < 2 ? 0 : 11 - rest;
    }

    return checkDigit(12) === parseInt(d.charAt(12), 10) && checkDigit(13) === parseInt(d.charAt(13), 10);
  }

  function collectFields(form) {
    var fields = {};
    var groups = {};
    var elements = form.elements;

    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (!el.name || el.name === 'website') continue;
      if (el.type === 'submit' || el.type === 'button' || el.type === 'file') continue;

      if (el.disabled) {
        if (!(el.name in fields)) fields[el.name] = '';
        continue;
      }

      if (el.type === 'radio') {
        if (el.checked) fields[el.name] = el.value;
        else if (!(el.name in fields)) fields[el.name] = '';
        continue;
      }

      if (el.type === 'checkbox') {
        if (!groups[el.name]) groups[el.name] = [];
        if (el.checked) groups[el.name].push(el.value || 'Sim');
        continue;
      }

      fields[el.name] = (el.value || '').trim();
    }

    Object.keys(groups).forEach(function (name) {
      fields[name] = groups[name].join(', ');
    });

    return fields;
  }

  function setStatus(statusEl, type, message) {
    if (!statusEl) return;
    statusEl.hidden = !message;
    statusEl.textContent = message || '';
    statusEl.classList.remove('ficha-ocorrencia__status--success', 'ficha-ocorrencia__status--error');
    if (type) statusEl.classList.add('ficha-ocorrencia__status--' + type);
  }

  function setLoading(form, loading, text) {
    var button = form.querySelector('[data-ficha-submit]');
    var label = form.querySelector('[data-ficha-submit-label]');
    var loadingLabel = form.querySelector('[data-ficha-submit-loading]');
    if (!button) return;

    if (loadingLabel) {
      if (!loadingLabel.hasAttribute('data-default-text')) {
        loadingLabel.setAttribute('data-default-text', loadingLabel.textContent);
      }
      loadingLabel.textContent = text || loadingLabel.getAttribute('data-default-text');
    }

    button.disabled = loading || !form.getAttribute('data-webhook-url');
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (label) label.hidden = loading;
    if (loadingLabel) loadingLabel.hidden = !loading;
  }

  function markInvalid(el, invalid) {
    if (invalid) el.setAttribute('aria-invalid', 'true');
    else el.removeAttribute('aria-invalid');
  }

  function validate(form) {
    var valid = true;

    REQUIRED_NAMES.forEach(function (name) {
      var el = form.elements.namedItem(name);
      if (!el || el.disabled) return;
      var empty = !(el.value || '').trim();
      markInvalid(el, empty);
      if (empty) valid = false;
    });

    var cnpj = form.elements.namedItem('cnpj');
    if (cnpj && cnpj.value && !isValidCnpj(cnpj.value)) {
      markInvalid(cnpj, true);
      valid = false;
    }

    ['email_lojista', 'email_consumidor'].forEach(function (name) {
      var el = form.elements.namedItem(name);
      if (!el || !el.value.trim()) return;
      var bad = !EMAIL_RE.test(el.value.trim());
      markInvalid(el, bad);
      if (bad) valid = false;
    });

    form.querySelectorAll('[data-required-group]').forEach(function (group) {
      var name = group.getAttribute('data-required-group');
      var checked = group.querySelector('input[name="' + name + '"]:checked');
      group.classList.toggle('ficha-ocorrencia__control--invalid', !checked);
      if (!checked) valid = false;
    });

    return valid;
  }

  function focusFirstInvalid(form) {
    var target =
      form.querySelector('[aria-invalid="true"]') ||
      form.querySelector('.ficha-ocorrencia__control--invalid input');
    if (target && typeof target.focus === 'function') target.focus();
  }

  function applyConditionals(form) {
    form.querySelectorAll('[data-show-when]').forEach(function (wrapper) {
      var rule = wrapper.getAttribute('data-show-when').split('=');
      var name = rule[0];
      var expected = rule.slice(1).join('=');
      var checked = form.querySelector('input[name="' + name + '"]:checked');
      var visible = !!checked && checked.value === expected;

      wrapper.hidden = !visible;
      wrapper.querySelectorAll('input, textarea, select').forEach(function (input) {
        input.disabled = !visible;
        if (visible) return;
        if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
        else input.value = '';
      });
    });
  }

  function isCompressibleImage(file) {
    return /^image\/(jpeg|png|webp)$/i.test(file.type);
  }

  function compressImage(file) {
    if (!isCompressibleImage(file) || file.size <= COMPRESS_ABOVE_BYTES) return Promise.resolve(file);

    return new Promise(function (resolve) {
      var url = URL.createObjectURL(file);
      var img = new Image();

      img.onload = function () {
        var scale = Math.min(1, IMAGE_MAX_DIMENSION / Math.max(img.naturalWidth, img.naturalHeight));
        var canvas = document.createElement('canvas');
        canvas.width = Math.round(img.naturalWidth * scale);
        canvas.height = Math.round(img.naturalHeight * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(url);

        canvas.toBlob(
          function (blob) {
            if (!blob || blob.size >= file.size) return resolve(file);
            var name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
            resolve(new File([blob], name, { type: 'image/jpeg' }));
          },
          'image/jpeg',
          IMAGE_QUALITY
        );
      };

      img.onerror = function () {
        URL.revokeObjectURL(url);
        resolve(file);
      };

      img.src = url;
    });
  }

  function initAnexos(form) {
    var state = {};
    var limits = {
      nota_fiscal: 1,
      fotos: parseInt(form.getAttribute('data-max-fotos'), 10) || 8,
      videos: parseInt(form.getAttribute('data-max-videos'), 10) || 0
    };

    function renderList(categoria, errors) {
      var list = form.querySelector('[data-file-list="' + categoria + '"]');
      if (!list) return;
      list.innerHTML = '';

      (state[categoria] || []).forEach(function (file) {
        var li = document.createElement('li');
        li.textContent = file.name + ' (' + formatBytes(file.size) + ')';
        list.appendChild(li);
      });

      errors.forEach(function (message) {
        var li = document.createElement('li');
        li.className = 'ficha-ocorrencia__file-error';
        li.textContent = message;
        list.appendChild(li);
      });
    }

    form.querySelectorAll('[data-anexo]').forEach(function (input) {
      var categoria = input.getAttribute('data-anexo');
      state[categoria] = [];

      input.addEventListener('change', function () {
        var accepted = [];
        var errors = [];
        var files = Array.prototype.slice.call(input.files || []);

        files.forEach(function (file) {
          var tooBig = file.size > MAX_FILE_BYTES && !isCompressibleImage(file);
          if (tooBig) {
            errors.push(
              file.name + ' tem ' + formatBytes(file.size) + ' e passa do limite de 4 MB. Use o campo de link abaixo.'
            );
            return;
          }
          if (accepted.length >= limits[categoria]) {
            errors.push(file.name + ' não foi incluído: limite de ' + limits[categoria] + ' arquivo(s).');
            return;
          }
          accepted.push(file);
        });

        state[categoria] = accepted;
        renderList(categoria, errors);
      });
    });

    return {
      list: function () {
        var all = [];
        Object.keys(state).forEach(function (categoria) {
          state[categoria].forEach(function (file) {
            all.push({ categoria: categoria, file: file });
          });
        });
        return all;
      },
      reset: function () {
        Object.keys(state).forEach(function (categoria) {
          state[categoria] = [];
          renderList(categoria, []);
        });
      }
    };
  }

  function parseResponse(response) {
    return response.text().then(function (text) {
      if (!response.ok) throw new Error('Webhook responded with ' + response.status);
      try {
        return JSON.parse(text);
      } catch (e) {
        return {};
      }
    });
  }

  function fileExtension(file) {
    var match = /\.([a-z0-9]+)$/i.exec(file.name);
    return match ? match[1].toLowerCase() : 'bin';
  }

  function uploadAnexos(url, protocolo, anexos, onProgress) {
    var failed = [];
    var total = anexos.length;

    return anexos
      .reduce(function (chain, item, index) {
        return chain.then(function () {
          onProgress(index + 1, total);
          return compressImage(item.file).then(function (file) {
            if (file.size > MAX_FILE_BYTES) {
              failed.push(item.file.name);
              return;
            }

            var name = protocolo + '_' + item.categoria + '_' + (index + 1) + '.' + fileExtension(file);
            var body = new FormData();
            body.append('protocolo', protocolo);
            body.append('categoria', item.categoria);
            body.append('indice', String(index + 1));
            body.append('total', String(total));
            body.append('nome_original', item.file.name);
            body.append('arquivo', file, name);

            return fetch(url, { method: 'POST', body: body })
              .then(function (response) {
                if (!response.ok) throw new Error('Upload responded with ' + response.status);
              })
              .catch(function () {
                failed.push(item.file.name);
              });
          });
        });
      }, Promise.resolve())
      .then(function () {
        return failed;
      });
  }

  function initForm(form) {
    var container = form.parentElement;
    var success = container.querySelector('[data-ficha-success]');
    var dateInput = form.querySelector('input[name="data_solicitacao"]');
    var anexos = initAnexos(form);

    function lockDate() {
      if (!dateInput) return;
      dateInput.value = todayISODate();
      dateInput.readOnly = true;
    }

    function resetForm() {
      form.reset();
      anexos.reset();
      form.querySelectorAll('[aria-invalid]').forEach(function (el) {
        el.removeAttribute('aria-invalid');
      });
      form.querySelectorAll('.ficha-ocorrencia__control--invalid').forEach(function (el) {
        el.classList.remove('ficha-ocorrencia__control--invalid');
      });
      lockDate();
      applyConditionals(form);
    }

    function showSuccess(protocolo, failedFiles) {
      if (!success) return;
      var date = dateInput ? dateInput.value : todayISODate();
      var template = form.getAttribute('data-success-message') || '';

      success.querySelector('[data-ficha-protocolo]').textContent = protocolo;
      success.querySelector('[data-ficha-success-message]').textContent = template.replace(/\[protocolo\]/g, protocolo);

      var consultaLink = success.querySelector('[data-ficha-consulta-link]');
      var consultaUrl = form.getAttribute('data-consulta-url') || '';
      if (consultaLink && consultaUrl) {
        var separator = consultaUrl.indexOf('?') === -1 ? '?' : '&';
        consultaLink.href =
          consultaUrl + separator + 'protocolo=' + encodeURIComponent(protocolo) + '&data=' + encodeURIComponent(date);
      }

      var warning = success.querySelector('[data-ficha-success-warning]');
      if (warning) {
        warning.hidden = !failedFiles.length;
        warning.textContent = failedFiles.length
          ? (form.getAttribute('data-anexos-error-message') || 'Alguns anexos não foram enviados:') +
            ' ' +
            failedFiles.join(', ')
          : '';
      }

      form.hidden = true;
      success.hidden = false;
      success.focus();
      success.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (success) {
      var copyButton = success.querySelector('[data-ficha-copy]');
      if (copyButton) {
        copyButton.addEventListener('click', function () {
          var text = success.querySelector('[data-ficha-protocolo]').textContent;
          if (!navigator.clipboard) return;
          navigator.clipboard.writeText(text).then(function () {
            var original = copyButton.textContent;
            copyButton.textContent = 'Copiado';
            setTimeout(function () {
              copyButton.textContent = original;
            }, 2000);
          });
        });
      }

      var newButton = success.querySelector('[data-ficha-new]');
      if (newButton) {
        newButton.addEventListener('click', function () {
          resetForm();
          setStatus(form.querySelector('[data-ficha-status]'), null, '');
          success.hidden = true;
          form.hidden = false;
          form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    var cnpjInput = form.querySelector('[data-mask="cnpj"]');
    if (cnpjInput) {
      cnpjInput.addEventListener('input', function () {
        cnpjInput.value = maskCnpj(cnpjInput.value);
      });
    }

    form.addEventListener('change', function (event) {
      if (event.target.type === 'radio') applyConditionals(form);
      if (event.target.type === 'checkbox') {
        var group = event.target.closest('[data-required-group]');
        if (group) group.classList.remove('ficha-ocorrencia__control--invalid');
      }
      if (event.target.getAttribute('aria-invalid')) event.target.removeAttribute('aria-invalid');
    });

    lockDate();
    applyConditionals(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var statusEl = form.querySelector('[data-ficha-status]');
      var webhookUrl = (form.getAttribute('data-webhook-url') || '').trim();
      var anexosUrl = (form.getAttribute('data-anexos-webhook-url') || '').trim();
      var honeypot = form.elements.namedItem('website');

      if (honeypot && honeypot.value) {
        setStatus(statusEl, 'success', 'Enviado.');
        resetForm();
        return;
      }

      if (!webhookUrl) {
        setStatus(statusEl, 'error', form.getAttribute('data-error-message') || 'Envio indisponível no momento.');
        return;
      }

      lockDate();

      if (!validate(form)) {
        setStatus(
          statusEl,
          'error',
          form.getAttribute('data-validation-message') || 'Preencha os campos obrigatórios.'
        );
        focusFirstInvalid(form);
        return;
      }

      var files = anexosUrl ? anexos.list() : [];
      var payload = {
        form: 'ficha_ocorrencia_tecnica',
        acao: 'registrar',
        submitted_at: new Date().toISOString(),
        shop: form.getAttribute('data-shop') || '',
        page_url: window.location.href,
        total_anexos: files.length,
        anexos: files.map(function (item) {
          return { categoria: item.categoria, nome: item.file.name };
        }),
        fields: collectFields(form)
      };

      setLoading(form, true);
      setStatus(statusEl, null, '');

      fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(parseResponse)
        .then(function (data) {
          var protocolo = data && data.protocolo ? String(data.protocolo).trim() : '';

          if (!protocolo) {
            setStatus(statusEl, 'success', 'Ficha enviada com sucesso. Nossa equipe retornará em até 72 horas.');
            resetForm();
            return;
          }

          if (!files.length) {
            showSuccess(protocolo, []);
            return;
          }

          return uploadAnexos(anexosUrl, protocolo, files, function (current, total) {
            setLoading(form, true, 'Enviando anexo ' + current + ' de ' + total + '…');
          }).then(function (failed) {
            showSuccess(protocolo, failed);
          });
        })
        .catch(function () {
          setStatus(
            statusEl,
            'error',
            form.getAttribute('data-error-message') || 'Não foi possível enviar a ficha.'
          );
        })
        .finally(function () {
          setLoading(form, false);
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-ficha-ocorrencia]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
